import { LIBRARY, Metadata } from "./Constants";
import Object from "./Object";
import * as THREE from "three";

class GenericObject extends Object {
  static cachedObjects: Map<string, THREE.Object3D> = new Map();

  metadata: Metadata;
  promise?: Promise<THREE.Mesh<THREE.BoxGeometry, THREE.MeshBasicMaterial[]>>;
  //   promise?: Promise<THREE.Mesh<THREE.BoxGeometry, THREE.MeshLambertMaterial>>;

  constructor(id: string, position?: THREE.Vector3) {
    super(position);
    this.metadata = LIBRARY[id] as Metadata;
    if (!this.metadata) {
      throw new Error(`ID ${id} not found`);
    }
    this.type_id = id;

    if (GenericObject.cachedObjects.has(id)) {
      this.asset = GenericObject.cachedObjects.get(id)?.clone();
    } else {
      this.promise = new THREE.TextureLoader()
        .loadAsync(`/images/${id}.jpg`)
        .then((value) => {
          const material = new THREE.MeshBasicMaterial({
            map: value,
            reflectivity: 0.5,
          });
          // Assuming 'value' is your original texture
          const textureFront = value.clone(); // Clone the original texture for the front
          // textureFront.rotation = Math.PI / 2; // Rotate the front texture by 90 degrees

          const textureLeft = value.clone(); // Clone the original texture for the back
          textureLeft.rotation = -Math.PI / 2; // Rotate the back texture by 180 degrees
          textureLeft.center.x = 0.5;
          textureLeft.center.y = 0.5;

          const textureRight = value.clone(); // Clone the original texture for the back
          textureRight.rotation = Math.PI / 2; // Rotate the back texture by 180 degrees
          textureRight.center.x = 0.5;
          textureRight.center.y = 0.5;

          const textureBack = value.clone(); // Clone the original texture for the back
          textureBack.rotation = Math.PI; // Rotate the back texture by 180 degrees
          textureBack.center.x = 0.5;
          textureBack.center.y = 0.5;

          const materials = [
            new THREE.MeshBasicMaterial({ map: textureRight }), // Front side with its adjusted texture
            new THREE.MeshBasicMaterial({ map: textureLeft }),
            new THREE.MeshBasicMaterial({ map: textureBack }), // Front side with its adjusted texture
            new THREE.MeshBasicMaterial({ map: textureFront }), // Front side with its adjusted texture
            new THREE.MeshBasicMaterial({ map: textureFront }), // Front side with its adjusted texture
            new THREE.MeshBasicMaterial({ map: textureFront }), // Front side with its adjusted texture
            // Repeat for each side, creating new texture instances and adjusting as necessary
          ];
          value.rotation = Math.PI;

          //   new THREE.MeshBasicMaterial({ map: value }), // Back side
          // const material = new THREE.MeshLambertMaterial({ map: value, reflectivity: 0.5 })
          const newObject = new THREE.Mesh(
            new THREE.BoxGeometry(0.8, 0.8, 0.8),
            materials
            // material
          );
          if (position) {
            newObject.position.copy(position);
          }
          return newObject;
        });
      // this.promise = new GLTFLoader().loadAsync("/glbs" + this.metadata.asset).then(glb => {
      //     const obj = glb.scene.children[0]
      //     obj.rotateX(Math.PI / 2)
      //     this.asset = obj
      //     GenericObject.cachedObjects.set(id, obj)
      //     return obj
      // })
    }
  }

  async getAsset() {
    if (!this.asset) {
      try {
        this.asset = await this.promise;
      } catch (error) {
        console.warn(error);
        console.warn(`Cannot load ${this.type_id}`);

        return new THREE.Mesh(
          new THREE.BoxGeometry(0.8, 0.8, 0.8),
          new THREE.MeshStandardMaterial({ color: 0x808080 })
        );
      }
    }
    if (!this.asset) {
      throw new Error(`Asset /images/${this.type_id}.jpg not found`);
    }

    this.instance_id = this.asset.id;
    return this.asset;
  }
}

export default GenericObject;
